// extracted by mini-css-extract-plugin
export default {"button":"PaymentSuccess_button__wRkKW"};